const CompHTML = ({
	html,
	element_type = "span",
	style_js = undefined,
	classname_s = undefined
}) => {
	let jsx;
	let props_js = {};

	if (classname_s !== undefined) {
		props_js["className"] = classname_s;
	}

	if (style_js !== undefined) {
		props_js["style"] = style_js;
	}

	switch (element_type) {
		case "span":
			jsx = <span {...props_js} dangerouslySetInnerHTML={{ __html: html }} />;
			break;
		case "div":
			jsx = <div {...props_js} dangerouslySetInnerHTML={{ __html: html }} />;
			break;
		default:
			jsx = <span {...props_js} dangerouslySetInnerHTML={{ __html: html }} />;
			break;
	}

	return jsx;
};

export default CompHTML;
